import { render, staticRenderFns } from "./ClassroomReportCard.vue?vue&type=template&id=e3a775f2&scoped=true&"
import script from "./ClassroomReportCard.vue?vue&type=script&lang=js&"
export * from "./ClassroomReportCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomReportCard.vue?vue&type=style&index=0&id=e3a775f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a775f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VDialog,VDivider,VIcon,VSelect,VSwitch})
